export const EnumWithTranslation = (props: {
  value: string;
  translations: { [key: string]: { color?: string; text?: string } };
}) => {
  const item = props.translations[props.value];
  return (
    <span style={{ color: item?.color }}>{item?.text ?? props.value}</span>
  );
};
